import React from 'react';
import Svg, { Circle, Path } from 'react-native-svg';

export const PlaceholderImgSVG: React.FC = () => (
  <Svg width={220} height={160} fill="none">
    <Circle cx={110} cy={80} r={80} fill="#EAECF0" fillOpacity={0.99} />
    <Circle cx={26} cy={20} r={8} fill="#F2F4F7" />
    <Circle cx={198} cy={126} r={6} fill="#F2F4F7" />
    <Circle cx={25} cy={138} r={10} fill="#F2F4F7" />
    <Circle cx={210} cy={38} r={10} fill="#F2F4F7" />
    <Circle cx={191} cy={11} r={7} fill="#F2F4F7" />
    <Path
      d="M100.75 28a3.75 3.75 0 0 1 3.75 3.75v12.5a3.75 3.75 0 0 1-7.5 0v-12.5a3.75 3.75 0 0 1 3.75-3.75Zm-23.902 9.85a3.75 3.75 0 0 1 5.304-.001l8.75 8.75a3.75 3.75 0 0 1-5.304 5.303l-8.75-8.75a3.75 3.75 0 0 1 0-5.303Zm47.804-.001a3.75 3.75 0 0 1 0 5.303l-8.75 8.75a3.75 3.75 0 0 1-5.304-5.303l8.75-8.75a3.751 3.751 0 0 1 5.304 0ZM67 61.75A3.75 3.75 0 0 1 70.75 58h12.5a3.75 3.75 0 1 1 0 7.5h-12.5A3.75 3.75 0 0 1 67 61.75Zm40.887-1.322C103.609 56.761 97 59.801 97 65.435v56.369c0 6.053 7.473 8.909 11.509 4.398l13.074-14.612a7.63 7.63 0 0 1 5.38-2.536l19.201-.768c5.988-.239 8.578-7.696 4.028-11.597l-42.305-36.26Zm-3.387 59.007V67.403l39.062 33.482-16.898.675a15.132 15.132 0 0 0-10.671 5.029L104.5 119.435Z"
      fill="#FAFCFF"
    />
  </Svg>
);
